
import { call, cancel, cancelled, delay, fork, take } from 'redux-saga/effects'

export const KEEP_CONNECTION_START_ACTION_TYPE = 'keepConnection/START';
export const KEEP_CONNECTION_STOP_ACTION_TYPE = 'keepConnection/STOP';

function keepConnection(urls) {
    const now = Date.now();
    urls.forEach(item => {
        const url = item.replace('{TICK}', now);
        fetch(url);
    });
}

export default function getActions(dispatch) {
    return {
        keepConnectionStart: (urls) => dispatch({
            type: KEEP_CONNECTION_START_ACTION_TYPE,
            urls,
        }),
        keepConnectionStop: () => dispatch({
            type: KEEP_CONNECTION_STOP_ACTION_TYPE
        }),
    };
}

function* keepConnectionTask(action) {
    try {
        const DELAY_MIN = 2;
        console.log(`keepConnection is running (delay ${DELAY_MIN} min)...`);
        while (true) {
            yield delay(DELAY_MIN * 60 * 1000);
            yield call(keepConnection, action.urls);
        }
    } finally {
        if (yield cancelled()) {
            console.log(`keepConnection is stopped`);
        }
    }
}

export function* keepConnectionWorkFlow() {
    while(true) {
        const action = yield take(KEEP_CONNECTION_START_ACTION_TYPE);
        const task = yield fork(keepConnectionTask, action);
        yield take(KEEP_CONNECTION_STOP_ACTION_TYPE);
        yield cancel(task);
    }
}
